/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import {
  ExperimentProvider,
  useExperimentationProviderOptions,
} from '@americanexpress/one-xp-client-sdk';

/**
 * OneXpWrapper is the new OneXpWrapper.
 * The key difference is the way the ExperimentProvider fetches experiments data.
 * It makes a single find call when the user navigates to a new page.
 * It uses app id in order to find its experiments.
 * you want to use this Wrapper if you are using the new OneXP Client Side decisioning.
 * Read more here https://one-dev.aexp.com/v1/one-xp/client-side-decisioning.html#article
 */
const OneXpWrapper = ({ children }) => {
  const options = useExperimentationProviderOptions();

  // eslint-disable-next-line react/jsx-props-no-spreading -- this is needed
  return <ExperimentProvider {...options}> {children}</ExperimentProvider>;
};

export default OneXpWrapper;

OneXpWrapper.propTypes = {
  children: PropTypes.node,
};
